"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import { getArticles } from "../../services/blogService";
import "../../styles/components/blog.scss";

export default function BlogPage() {
  const [articles, setArticles] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadArticles();
  }, []);

  async function loadArticles() {
    const data = await getArticles();
    setArticles(data);
  }

  const filtered = articles.filter((a) =>
    a.title.toLowerCase().includes(search.toLowerCase())
  );

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className="blog_page">
      {/* HEADER */}
      <div className="blog_header">
        <div className="blog_header_inner">
          <span className="blog_header_label">Our</span>
          <h1 className="blog_header_title">Blog</h1>
        </div>
        <div className="blog_header_decoration" aria-hidden="true">
          <span className="deco_circle deco_circle--1" />
          <span className="deco_circle deco_circle--2" />
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="blog_container">
        {/* LEFT BLOG LIST */}
        <div className="blog_list">
          {filtered.length === 0 && (
            <p className="blog_empty">No articles found.</p>
          )}
          {filtered.map((article, i) => (
            <div key={article.id} className="blog_card">
              <div className="blog_card_image">
                <img src={article.cover.url} alt={article.title} />
                <span className="blog_card_date_badge">
                  {formatDate(article.createdAt)}
                </span>
              </div>

              <div className="blog_card_content">
                <div className="blog_card_meta">
                  <span className="meta_author">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                    {article.author.name || "John Doe"}
                  </span>
                  <span className="meta_divider" />
                  <span className="meta_category">{article.category || "Logistics"}</span>
                </div>

                <h2 className="blog_card_title">{article.title}</h2>
                <p className="blog_card_desc">{article.description}</p>

                <Link href={`/blogs/${article.documentId}`} className="blog_card_link">
                  Read More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* SIDEBAR */}
        <aside className="blog_sidebar">
          {/* Search */}
          <div className="sidebar_search">
            <input
              placeholder="Search articles..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="search_btn" aria-label="Search">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" />
              </svg>
            </button>
          </div>

          {/* Latest Posts */}
          <div className="sidebar_section">
            <h3 className="sidebar_title">
              <span>Latest Posts</span>
              <span className="sidebar_title_line" />
            </h3>

            <div className="latest_posts">
              {/* First post — large featured card */}
              {articles[0] && (
                <Link
                  href={`/blogs/${articles[0].documentId}`}
                  className="latest_post_featured"
                >
                  <div className="latest_post_featured_img">
                    <img src={articles[0].cover.url} alt={articles[0].title} />
                    <div className="latest_post_featured_overlay" />
                  </div>
                  <div className="latest_post_featured_info">
                    <div className="latest_post_featured_meta">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                      {formatDate(articles[0].createdAt)}
                      <span className="dot">·</span>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      {articles[0].author.name || "John Doe"}
                    </div>
                    <p className="latest_post_featured_title">{articles[0].title}</p>
                  </div>
                </Link>
              )}

              {/* Remaining posts — compact list */}
              {articles.slice(1, 5).map((post) => (
                <Link
                  key={post.id}
                  href={`/blogs/${post.documentId}`}
                  className="latest_post_item"
                >
                  <div className="latest_post_thumb">
                    <img src="/placeholder.jpg" alt={post.title} />
                  </div>
                  <div className="latest_post_info">
                    <p className="latest_post_title">{post.title}</p>
                    <span className="latest_post_meta">
                      {formatDate(post.createdAt)} · {post.author.name || "John Doe"}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}